// eslint-disable-next-line no-shadow
export enum LOCAL_STORAGE_KEYS {
  lastLocation = 'last_location',
  lastLanguage = 'last_language',
  lastIdentity = 'last_identity',
  lastProfile = 'last_profile'
}
